import { AiOutlineCheck } from "react-icons/ai";

function ListItem({ item }: any) {
  return (
    <div className="text-center px-3 border-blue-gray-100">
      <div className="mb-5">
        <div className="bg-white shadow-md rounded-lg p-4">
          <AiOutlineCheck size={30} className="m-auto mb-4" />
          <h4 className="text-lg font-bold mb-4 flex items-center justify-center">
            {item.title}
          </h4>
          <p className="text-base text-gray-600">{item.text}</p>
        </div>
      </div>
    </div>
  );
}

export function AboutUs({ texts }: any) {
  return (
    <section
      id="about"
      className="lg:w-full w-[90%] max-w-6xl mx-auto flex flex-col items-center px-10 py-20"
    >
      <div>
        <h1 className="text-3xl font-bold text-center text-blue-gray-900">
          {texts.titleOne}
        </h1>
        <p className="text-lg font-normal text-gray-600 max-w-4xl mx-auto mt-4 text-center">
          {texts.contentOne}
        </p>
      </div>
      <div className="w-1/2 mx-auto border-t border-gray-300 my-10" />
      <div>
        <h1 className="text-3xl font-bold text-center text-blue-gray-900">
          {texts.titleTwo}
        </h1>
        <p className="text-lg font-normal text-gray-600 max-w-4xl mx-auto mt-4 text-center">
          {texts.contentTwo}
        </p>
      </div>
      <div className="w-1/2 mx-auto border-t border-gray-300 my-10" />
      <div>
        <h1 className="text-3xl font-bold text-center text-blue-gray-900">
          {texts.titleThree}
        </h1>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {texts.data.slice(0, 3).map((item: any) => (
            <ListItem key={item.text} item={item} />
          ))}
        </div>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
          {texts.data.slice(3, 5).map((item: any) => (
            <ListItem key={item.text} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
